/** @format */

import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import axios from 'src/utils/axios';
import { ENDPOINTS } from 'src/constants';
import type { AppThunk } from 'src/store';
import type { ShopOrder, ShopOrdersResponse } from 'src/types';

export interface ShopOrdersState {
  ordersLoading: boolean;
  orders: ShopOrder[] | null;
  error: unknown;
}

const initialState: ShopOrdersState = {
  ordersLoading: false,
  orders: null,
  error: null
};

const slice = createSlice({
  name: 'shopOrders',
  initialState,
  reducers: {
    getOrders(state) {
      state.ordersLoading = true;
    },
    getOrdersSuccess(state, action: PayloadAction<ShopOrdersResponse | null | undefined>) {
      const data = action.payload;
      state.orders = data?.orders || [];
      state.ordersLoading = false;
    },
    getOrdersFailure(state, action: PayloadAction<unknown>) {
      state.error = action.payload;
      state.ordersLoading = false;
    }
  }
});

export const reducer = slice.reducer;

export const getShopOrders =
  (): AppThunk =>
  async dispatch => {
    const { getOrders, getOrdersSuccess, getOrdersFailure } = slice.actions;
    try {
      dispatch(getOrders());
      const response = await axios.get<ShopOrdersResponse>(ENDPOINTS.GET_SHOP_ORDERS_ENDPOINT);
      dispatch(getOrdersSuccess(response.data));
    } catch (err) {
      dispatch(getOrdersFailure(err));
    }
  };

export default slice;
